import React from "react";
import { Box, Container, Stack, Typography, Link } from "@mui/material";
import { PageProps, graphql, navigate } from "gatsby";
import NavigationWrapper from "../components/layout/NavigationWrapper";
import SEO from "../components/Seo";
import COLORS from "../constants/colors";
import Display from "../components/layout/Display";
import InlineFaq from "../components/faq/InlineFaq";
import useIsMobile from "../hooks/useIsMobile";
import { baseUrlWithoutSlash } from "../utils/url";
import PartnerBanks from "../components/PartnerBanks";
import InsuranceAssistant from "../assets/svgs/insurance-assistant.svg";
import BalanceGuy from "../assets/images/balance-guy.png";
import SplitContentBlock from "../components/SplitContentBlock";
import Vipps from "../assets/svgs/Vipps.svg";
import BalanceGuyMobile from "../assets/images/balance-guy-mobile.png";
import FilePdf from "../assets/svgs/Pdf-logo.svg";
import InsuranceAssistantMobile from "../assets/svgs/insurance-assistant-mobile.svg";
import HammockNature from "../assets/images/HammockNature.png";
import HammockNatureMobile from "../assets/images/HammockNatureMobile.png";

const BaseUrl = baseUrlWithoutSlash();
const InsurancePage = ({ data }: PageProps<Queries.AppPageQuery>) => {
  const isMobile = useIsMobile();

  const faq = {
    sectionHeader: "Spørsmål og svar om forsikring",
    questions: [
      {
        question: "Hva koster innteksforsikring?",
        _rawAnswer: [
          {
            _key: "q1",
            _type: "block",
            children: [
              {
                _key: "a1",
                _type: "span",
                marks: [],
                text: "Du betaler 8% av valgt dekningsbeløp per måned. Det betyr for eksempel at hvis du har valgt dekning på 1 000 kroner i måneden, vil forsikringen koste 80 kroner i måneden.  ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question: "Hvem kan kjøpe betalingsforsikringen på lån?",
        _rawAnswer: [
          {
            _key: "q2",
            _type: "block",
            children: [
              {
                _key: "a2",
                _type: "span",
                marks: [],
                text: "\u2022 Du er mellom 18 og 65 år, har fast bosted i Norge og er medlem av norsk folketrygd, eller tilsvarende ordning i Norden.  ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q2",
            _type: "block",
            children: [
              {
                _key: "a2",
                _type: "span",
                marks: [],
                text: "\u00A0",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q2",
            _type: "block",
            children: [
              {
                _key: "a2",
                _type: "span",
                marks: [],
                text: "\u2022 Du er ansatt i 50 % stilling eller er selvstendig næringsdrivende.  ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q2",
            _type: "block",
            children: [
              {
                _key: "a2",
                _type: "span",
                marks: [],
                text: "\u00A0",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q2",
            _type: "block",
            children: [
              {
                _key: "a2",
                _type: "span",
                marks: [],
                text: "\u2022 Du mottar ikke sykepenger, AAP, dagpenger eller uføretrygd.  ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q2",
            _type: "block",
            children: [
              {
                _key: "a2",
                _type: "span",
                marks: [],
                text: "\u00A0",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q2",
            _type: "block",
            children: [
              {
                _key: "a2",
                _type: "span",
                marks: [],
                text: "\u2022 Du har ikke fått personlig varsel om arbeidsledighet eller permittering. ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question: "Hvordan kjøper jeg inntektsforsikring?",
        _rawAnswer: [
          {
            _key: "q3",
            _type: "block",
            children: [
              {
                _key: "a3",
                _type: "span",
                marks: [],
                text: "Forsikringen er et tilleggsvalg du gjør i slutten av lånesøknaden. Du kan kjøpe forsikringen uten å ta lån gjennom Horde, dette er uavhengig av hverandre. Bekreft avtalen i to enkle steg og betal med Vipps. Vi trekker månedsbeløpet fra Vipps inntil forsikringen blir sagt opp. Sier du opp forsikringen innen angrefristen på 14 dager, tilbakefører vi innbetalt premie.",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question: "Fra når er jeg forsikret?",
        _rawAnswer: [
          {
            _key: "q4",
            _type: "block",
            children: [
              {
                _key: "a4",
                _type: "span",
                marks: [],
                text: "Forsikringen gjelder fra og med den dagen du kjøper den. Bekreftelsen sender vi til deg på e-post, og forsikringsbeviset finner du i appen under din profil. ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question: "Hva betyr karensperiode og egenandelsperiode?",
        _rawAnswer: [
          {
            _key: "q5",
            _type: "block",
            children: [
              {
                _key: "a5",
                _type: "span",
                marks: [],
                text: "Karensperiode er perioden fra dagen du kjøpte forsikringen, til du kan melde skade. Perioden er 30 dager for sykemelding og 90 dager for arbeidsledighet eller permittering.",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q5",
            _type: "block",
            children: [
              {
                _key: "a5",
                _type: "span",
                marks: [],
                text: "\u00A0",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q6",
            _type: "block",
            children: [
              {
                _key: "a6",
                _type: "span",
                marks: [],
                text: "Egenandelsperiode er perioden fra du har meldt skade, til du kan få utbetalt erstatning. Perioden er 30 dager for både sykemelding og arbeidsledighet eller permittering.",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },

      {
        question: "Hvordan betaler jeg for inntektsforskring?",
        _rawAnswer: [
          {
            _key: "q6",
            _type: "block",
            children: [
              {
                _key: "a6",
                _type: "span",
                marks: [],
                text: "Vi trekker beløpet månedlig via Vipps. Det er derfor viktig at det alltid er dekning på kontoen beløpet trekkes fra. ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question: "Hva skjer om jeg ikke betaler forsikringen?",
        _rawAnswer: [
          {
            _key: "q7",
            _type: "block",
            children: [
              {
                _key: "a7",
                _type: "span",
                marks: [],
                text: "Vi varsler deg om manglende betaling. Dersom utestående beløp ikke gjøres opp, sier vi opp forsikringen fra vår side, og du er ikke lengre dekket.",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question: "Hvordan melder jeg skade?",
        _rawAnswer: [
          {
            _key: "q8",
            _type: "block",
            children: [
              {
                _key: "a8",
                _type: "span",
                marks: [],
                text: "Finn skademeldingsskjema via lenke under din profil i Horde-appen, og fra footer på nettsiden. Du melder skade direkte til skadebehandler IMAA. De utfører skadebehandlingen på vegne av forsikringsselskapet AmTrust. Horde formidler forsikringen på vegne av AmTrust.",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question:
          "Må jeg betale på forsikringen mens jeg får utbetalt penger fra forsikringsselskapet?",
        _rawAnswer: [
          {
            _key: "q9",
            _type: "block",
            children: [
              {
                _key: "a9",
                _type: "span",
                marks: [],
                text: "Ja, du må fortsatt betale premien til Horde. Men beløpet vil bli tilbakebetalt i sin helhet som en del av skadeutbetalingen.",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question: "Hvordan får jeg pengene hvis inntektsforsikring utløses?",
        _rawAnswer: [
          {
            _key: "q10",
            _type: "block",
            children: [
              {
                _key: "a10",
                _type: "span",
                marks: [],
                text: "Du får beløpet du er dekket for, rett inn på kontoen din, forutsatt at skaden er godkjent av forsikringsselskapet.",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q10",
            _type: "block",
            children: [
              {
                _key: "a10",
                _type: "span",
                marks: [],
                text: "\u00A0",
              },
            ],
            markDefs: [],
            style: "normal",
          },
          {
            _key: "q10",
            _type: "block",
            children: [
              {
                _key: "a10",
                _type: "span",
                marks: [],
                text: "Utbetalingen gjelder i inntil 12 måneder per skadetilfelle så lenge du er permittert, arbeidsledig eller sykemeldt ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
      {
        question: "Hvordan avslutter jeg inntektsforsikring?",
        _rawAnswer: [
          {
            _key: "q10",
            _type: "block",
            children: [
              {
                _key: "a10",
                _type: "span",
                marks: [],
                text: "Det gjør du i Horde-appen. Dekningen opphører når perioden du har betalt for er over. Utløpsdatoen finner du i appen under din profil. Vi sender deg også bekreftelse på mottatt oppsigelse på e-post. ",
              },
            ],
            markDefs: [],
            style: "normal",
          },
        ],
      },
    ],
  };

  const faqQuestions = faq
    ? faq.questions.map((q: any) => ({
        question: q?.question,
        answer: q?._rawAnswer,
      }))
    : [];

  return (
    <NavigationWrapper>
      <Stack component="section">
        <Box bgcolor={COLORS.BRIGHT_BLUE[20]}>
          <Container>
            <Stack
              flexDirection={{ xs: "column-reverse", md: "row" }}
              pt={{ xs: "26px", md: "80px" }}
              pb={{ xs: "40px", md: "100px" }}
            >
              <Stack gap={{ xs: "48px", md: "24px" }}>
                <Stack
                  gap={{ xs: "24px", md: "40px" }}
                  alignItems="flex-start"
                  maxWidth="500px"
                >
                  <Stack>
                    <Stack
                      gap={{ xs: "24px", md: "32px" }}
                      pt={{ xs: "20px", md: "40px" }}
                    >
                      <Typography variant="h1" color={COLORS.BLUE[100]}>
                        inntektsforsikring
                      </Typography>
                      <Typography variant="lead" color={COLORS.BLUE[100]}>
                        Sikre forutsigbarhet i økonomien selv om du blir
                        arbeidsledig, permittert eller sykemeldt.
                        Inntektsforsikring kjøper du i forbindelse med
                        lånesøknad.
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
              <Stack
                alignItems={{ xs: "center", md: "flex-end" }}
                flex={1}
                display={{ xs: "none", md: "flex" }}
              >
                <InsuranceAssistant width="100%" />
              </Stack>
              <Stack
                alignItems={{ xs: "center", md: "flex-end" }}
                flex={1}
                display={{ xs: "flex", md: "none" }}
              >
                <InsuranceAssistantMobile width="100%" />
              </Stack>
            </Stack>
          </Container>
        </Box>
      </Stack>
      <Box bgcolor={COLORS.BRIGHT_BLUE[40]}>
        <Container maxWidth="lg">
          <Stack
            component="section"
            py={{ xs: "28px", md: "66px" }}
            px={{ xs: "8px", md: "0px" }}
          >
            <Stack
              src={BalanceGuyMobile}
              component="img"
              display={{ xs: "block", md: "none" }}
            />
            <SplitContentBlock
              direction={isMobile ? "column-reverse" : "row-reverse"}
              gap={isMobile ? "0px" : "0px"}
              paddingTop={isMobile ? "0px" : "0px"}
            >
              <Stack
                gap={{ xs: "12px", md: "32px" }}
                alignItems="flex-start"
                justifyContent="flex-start"
                paddingLeft={{ xs: "20px", md: "60px" }}
                paddingTop={{ xs: "20px", md: "30px" }}
                paddingRight={{ xs: "20px", md: "30px" }}
                paddingBottom={{ xs: "20px", md: "0px" }}
                bgcolor={COLORS.BRIGHT_BLUE[20]}
                height="100%"
                sx={{
                  borderTopRightRadius: { xs: "0px", md: "50px" },
                  borderBottomRightRadius: { xs: "30px", md: "50px" },
                  borderBottomLeftRadius: { xs: "30px", md: "0px" },
                }}
              >
                <Typography variant="h2" color={COLORS.BLUE[100]}>
                  Dette er inntektsforsikring
                </Typography>
                <Typography variant="body" color={COLORS.BLUE[100]}>
                  Med inntektsforsikring får du erstatning dersom du blir
                  permittert, arbeidsledig eller minst 50% sykemeldt. Perioden
                  må sammenhengende være over 30 dager. Basert på valgt dekning
                  kan du få fra 1000-10 000 kroner rett på konto, hver måned.
                </Typography>
                <Stack
                  spacing={{ xs: "20px", md: "0px" }}
                  paddingTop={{ xs: "10px", md: "0px" }}
                >
                  <Link
                    href={`${BaseUrl}/forsikring/forsikringsvilkaar.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <FilePdf />
                    <Typography variant="body1">Forsikringsvilkår</Typography>
                  </Link>

                  <Link
                    href={`${BaseUrl}/forsikring/produktinformasjon.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <FilePdf />
                    <Typography variant="body1">Produktinformasjon</Typography>
                  </Link>

                  <Link
                    href={`${BaseUrl}/forsikring/forkjopsinformasjon.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <FilePdf />
                    <Typography variant="body1">Forkjøpsinformasjon</Typography>
                  </Link>
                </Stack>
              </Stack>

              <Stack
                width="100%"
                height="100%"
                src={BalanceGuy}
                component="img"
                display={{ xs: "none", md: "block" }}
              />
            </SplitContentBlock>
          </Stack>
        </Container>
      </Box>
      <Box bgcolor={COLORS.DARK_BLUE[100]}>
        <Container maxWidth="lg">
          <Stack
            component="section"
            py={{ xs: "28px", md: "90px" }}
            px={{ xs: "8px", md: "0px" }}
          >
            <Stack
              src={HammockNatureMobile}
              component="img"
              display={{ xs: "block", md: "none" }}
            />
            <SplitContentBlock direction={isMobile ? "column-reverse" : "row"}>
              <Stack
                gap={{ xs: "24px", md: "18px" }}
                alignItems="flex-start"
                justifyContent="flex-start"
                padding={{ xs: "20px", md: "52px" }}
                bgcolor={COLORS.WHITE[100]}
                sx={{
                  borderTopLeftRadius: { xs: "0px", md: "50px" },
                  borderBottomLeftRadius: { xs: "30px", md: "50px" },
                  borderBottomRightRadius: { xs: "30px", md: "0px" },
                }}
              >
                <Typography variant="h2Small" color={COLORS.BLUE[100]}>
                  pris og verdi er to ulike ting
                </Typography>
                <Typography
                  variant="body"
                  color={COLORS.BLUE[100]}
                  maxWidth="480px"
                >
                  For så lite som 80 kroner måneden slipper du å uroe deg dersom
                  du blir permittert, arbeidsledig eller langtidssykemeldt. En
                  Inntektsforsikring hjelper deg å dekke dine løpende
                  låneutgifter.
                </Typography>
                <Typography variant="body" color={COLORS.BLUE[100]}>
                  <span style={{ fontWeight: "bold" }}>
                    {" "}
                    Slik regnes prisen ut :{" "}
                  </span>{" "}
                  Du betaler 8% av valgt dekningsbeløp. 1000 kr dekning/md
                  koster 80 kroner i måneden. 2 000 kr koster 160 kroner i
                  måneden. Og så videre.
                </Typography>
              </Stack>

              <Stack
                width="100%"
                height="100%"
                src={HammockNature}
                sx={{
                  aspectRatio: "16/9",
                }}
                component="img"
                display={{ xs: "none", md: "block" }}
              />
            </SplitContentBlock>

            <Stack paddingTop={{ xs: "28px", md: "80px" }}>
              <Stack
                component="section"
                bgcolor={COLORS.TRUE_WHITE[100]}
                borderRadius={{ xs: "30px", md: "60px" }}
              >
                <Container>
                  <Stack
                    flexDirection={{ xs: "column", md: "row" }}
                    pt={{ xs: "5px", md: "60px" }}
                    pb={{ xs: "40px", md: "80px" }}
                    alignItems="center"
                    flex={1}
                    display={{ xs: "flex", md: "flex" }}
                  >
                    <Stack
                      alignItems="center"
                      flex={1}
                      display={{ xs: "flex", md: "flex" }}
                      pb={{ xs: "15px", md: "0px" }}
                    >
                      <Vipps width="100%" />
                    </Stack>

                    <Stack
                      gap={{ xs: "24px", md: "32px" }}
                      maxWidth="600px"
                      paddingLeft="20px"
                    >
                      <Typography variant="h2" color={COLORS.BLUE[100]}>
                        betal med Vipps
                      </Typography>
                      <Typography variant="lead" color={COLORS.BLUE[100]}>
                        Når du har valgt dekningsbeløp og bekreftet avtalen,
                        betaler du enkelt i Vipps. Vi trekker beløpet månedlig.
                      </Typography>
                    </Stack>
                  </Stack>
                </Container>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </Box>

      <Stack component="section">
        <Box
          bgcolor={isMobile ? COLORS.BRIGHT_BLUE[20] : COLORS.BRIGHT_BLUE[40]}
          display="flex"
          alignContent="center"
          justifyContent="center"
          py={{ md: "80px", xs: "25px" }}
        >
          <Container>
            <Display desktop>
              <Box
                bgcolor={COLORS.BRIGHT_BLUE[20]}
                py="120px"
                px="100px"
                borderRadius={isMobile ? "0" : "20px"}
              >
                {faq && (
                  <InlineFaq
                    headerText={faq.sectionHeader ?? ""}
                    items={faqQuestions}
                  />
                )}
                <Stack alignItems="center" paddingTop="60px">
                  <Stack
                    bgcolor={COLORS.DARK_BLUE[100]}
                    borderRadius="20px"
                    py={{ xs: "24px", md: "48px" }}
                    px={{ xs: "24px", md: "60px" }}
                    alignItems="center"
                    justifyContent="center"
                    gap="16px"
                    minWidth="60%"
                  >
                    <Typography variant="h4" textAlign="center">
                      Lurer du på noe annet?
                    </Typography>
                    <Typography textAlign="center">
                      Kontakt oss på{" "}
                      <Link href="mailto:support@horde.no" color="secondary">
                        support@horde.no
                      </Link>
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            </Display>
            <Display mobile>
              {faq && (
                <InlineFaq
                  headerText={faq.sectionHeader ?? ""}
                  items={faqQuestions}
                />
              )}
              <Stack alignItems="center" paddingTop="60px">
                <Stack
                  bgcolor={COLORS.DARK_BLUE[100]}
                  borderRadius="20px"
                  py={{ xs: "24px", md: "48px" }}
                  px={{ xs: "24px", md: "60px" }}
                  alignItems="center"
                  justifyContent="center"
                  gap="16px"
                  minWidth="60%"
                >
                  <Typography variant="h4" textAlign="center">
                    Lurer du på noe annet?
                  </Typography>
                  <Typography textAlign="center">
                    Kontakt oss på{" "}
                    <Link href="mailto:support@horde.no" color="secondary">
                      support@horde.no
                    </Link>
                  </Typography>
                </Stack>
              </Stack>
            </Display>
          </Container>
        </Box>
      </Stack>
      <Stack
        component="section"
        bgcolor={COLORS.TRUE_WHITE[100]}
        py={{ xs: "24px", md: "48px" }}
      >
        <Container maxWidth="xl" disableGutters={isMobile}>
          <Stack gap="48px" alignItems="center">
            <Typography variant="h2" color={COLORS.BLUE[100]}>
              Samarbeidsbanker{" "}
            </Typography>
            <PartnerBanks />
          </Stack>
        </Container>
      </Stack>
    </NavigationWrapper>
  );
};

export default InsurancePage;

export function Head() {
  return (
    <SEO
      title="Forsikring - Horde"
      description="Få bedre økonomisk trygghet dersom noe uforutsett skjer, med en inntektsforsikring tilpasset dine behov."
      image=""
    />
  );
}
